module.exports = __webpack_public_path__ + "img/customer-service.7460972c.png";